import { Alert, Box, Typography } from "@mui/material";
import { useDashboardAccess } from "./DashboardAccessProvider";
import { DashboardFilterBar } from "./DashboardFilterBar";
import { DashboardRefreshButton } from "./DashboardRefreshButton";
import { DrillDownProvider } from "./DrillDownProvider";
import { GlobalFilterConfig, GlobalFilterValues } from "./types";

type DashboardPageProps = {
    title?: string;
    globalFilters: Array<GlobalFilterConfig>;
    values: GlobalFilterValues;
    onChange: (filterKey: string, value: string | number | null) => void;
    children: React.ReactNode;
};

export const DashboardPage = ({ title, globalFilters, values, onChange, children }: DashboardPageProps) => {
    const { viewerRuleMissing } = useDashboardAccess();

    // Fail-closed: viewer_rules existem mas nenhuma regra bate no role do utilizador → sem dados.
    if (viewerRuleMissing) {
        return (
            <Box p={4}>
                {title && (
                    <Typography variant="h5" fontWeight={600} mb={3}>
                        {title}
                    </Typography>
                )}
                <Alert severity="warning">
                    O teu perfil ainda não tem uma regra de visualização definida para este dashboard. Pede à direção para configurar o
                    acesso.
                </Alert>
            </Box>
        );
    }

    return (
        <DrillDownProvider>
            <Box p={4}>
                {title && (
                    <Typography variant="h5" fontWeight={600} mb={3}>
                        {title}
                    </Typography>
                )}
                <Box display="flex" alignItems="flex-start" gap={3} flexWrap="wrap" mb={4}>
                    <DashboardFilterBar globalFilters={globalFilters} values={values} onChange={onChange} />
                    <DashboardRefreshButton />
                </Box>
                <Box display="flex" flexDirection="column" gap={4}>
                    {children}
                </Box>
            </Box>
        </DrillDownProvider>
    );
};
